import React from 'react';
import {useStores} from "../../stores";
import {VacancyCompanyHook} from "../../api/vacancy-company";
import SearchSelect from "../search-select";
type FilterVacancyCompanyProps = {
  selectedValue: any
  onValueChange: (name: string, value: string) => void
  fieldName?: string
  className?: string
}
export const FilterVacancyCompany = ({selectedValue, onValueChange, fieldName, className}: FilterVacancyCompanyProps) => {
  const { authStore } = useStores()
  const {data: VacancyCompanyList } = VacancyCompanyHook.useVacancyCompanies()

  const vacancyCompanyResponse: { id: number; name: string }[] =
    VacancyCompanyList && VacancyCompanyList[0]?.map(({ id, name }) => ({
      id: Number(id),
      name
    })) || [];

  if (authStore.user?.vacancyCompany) return null

  const name = fieldName || 'vacancyCompany'

  return (
    <>
      {!authStore.user?.vacancyCompany && (
        <div className={className}>
          <label className='form-label'>Заказчик</label>
          <div className='d-flex w-full'>
            <SearchSelect
              selectedValue={selectedValue}
              onValueChange={(e) => onValueChange(name, e)}
              sortedCurrentDic={vacancyCompanyResponse}
              maxHeight={'200px'}
              name={name}
              placeholder={"Выберите заказчика..."}
            />
          </div>
        </div>
      )}
    </>
  );
};